// Module
var code = "<span class=\"dc-status\" ng-class=\"$ctrl.getStatusCssClass($ctrl.status)\">{{ $ctrl.getStatusLabel($ctrl.status) }}</span> ";
// Exports
module.exports = code;